import Cookies from 'js-cookie';
import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Constants } from '../../utility/constants';

const BlankPage = lazy(() => import('../../pages/BlankPage'));
const OverviewData = lazy(() => import('../../pages/OverviewData/OverviewDataPage'));
function PagesRoute() {
  return (
    <Routes>
      {[Constants.admin.role.superAdmin].includes(Cookies.get(`role`)) && <Route index element={<OverviewData />} />}
      <Route path="*" element={<BlankPage />} />
    </Routes>
  );
}

export default PagesRoute;
